/* ═══════════ ATYR STUDIO — presentment-aware money formatting ═══════════
   Any price BUILT IN JAVASCRIPT must go through this.

   Why: Shopify.formatMoney(cents, shop.money_format) uses the STORE'S BASE
   currency format (USD/AED). Shopify's AJAX APIs return cents already
   converted into the shopper's market currency, so the number came out
   right but the symbol was always the base one — a £ price rendered as
   "Dhs. 150". Liquid's `{{ price | money }}` is presentment-aware; JS is not,
   so we read the live currency from Shopify.currency.active instead.

   Output deliberately matches what Liquid renders, so JS-built and
   Liquid-built prices are identical on the page (price-trim.js then strips
   any trailing .00 from both, and in Kuwait kuwait-currency.js converts
   both to display KWD).                                                    */
(function () {
  'use strict';

  function activeCurrency() {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return window.atyrShopCurrency || 'USD';
  }

  /* Learn symbol placement + separators from a Liquid-rendered sample
     (window.atyrMoneySample, e.g. "€1.234,56" or "Dhs. 1,234.56"). */
  var _pat;
  function pattern() {
    if (_pat !== undefined) return _pat;
    _pat = null;
    var sample = window.atyrMoneySample;
    if (sample) {
      var m = String(sample).match(/\d[\d.,\s\u00A0]*\d|\d/);
      if (m) {
        var core = m[0];
        var dm = core.match(/([.,])(\d{2})$/);          // decimal separator
        var tm = core.match(/\d([.,\s\u00A0])\d{3}/);  // thousands separator
        _pat = {
          prefix: String(sample).slice(0, m.index),
          suffix: String(sample).slice(m.index + core.length),
          dec:    dm ? dm[1] : '',
          thou:   tm ? tm[1] : ''
        };
      }
    }
    return _pat;
  }

  /* cents = minor units in the CURRENT market currency (what /cart.js,
     /recommendations and variant JSON already return) */
  window.atyrMoney = function (cents) {
    var minor;
    if (typeof cents === 'string' && cents.indexOf('.') !== -1) {
      minor = Math.round(parseFloat(cents) * 100);      // "12.50" style
    } else {
      minor = parseInt(cents, 10) || 0;
    }
    var amount = minor / 100;
    var cur = activeCurrency();

    /* Preferred: mirror the pattern Liquid just rendered for this market */
    var pat = pattern();
    if (pat) {
      var fixed = amount.toFixed(pat.dec ? 2 : 0);
      var bits  = fixed.split('.');
      var whole = bits[0].replace(/\B(?=(\d{3})+(?!\d))/g, pat.thou || '');
      return pat.prefix + whole + (pat.dec ? pat.dec + bits[1] : '') + pat.suffix;
    }

    /* Fallbacks if no sample is available */
    if (cur === 'AED') {
      return 'Dhs. ' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: cur }).format(amount);
    } catch (e) {
      return amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + cur;
    }
  };
}());
